var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarrierWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.54 12.6666C29.54 12.4595 29.3721 12.2916 29.165 12.2916H27.0938L24.4087 19.7916H29.54V12.6666ZM18.3003 19.7916H22.0181L24.7031 12.2916H20.9854L18.3003 19.7916ZM12.1904 19.7916H15.9082L18.5947 12.2916H14.8755L12.1904 19.7916ZM7.79004 19.7916H9.7998L12.4849 12.2916H8.16504C7.95793 12.2916 7.79004 12.4595 7.79004 12.6666V19.7916ZM31.79 32.1666C31.79 32.7879 31.2864 33.2916 30.665 33.2916C30.0437 33.2916 29.54 32.7879 29.54 32.1666V22.0416H7.79004V32.1666C7.79004 32.7879 7.28636 33.2916 6.66504 33.2916C6.04372 33.2916 5.54004 32.7879 5.54004 32.1666V12.6666C5.54004 11.2169 6.71529 10.0416 8.16504 10.0416H29.165C30.6148 10.0416 31.79 11.2169 31.79 12.6666V32.1666Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarrierWhite);
export default __webpack_public_path__ + "static/media/barrier-white.53bdd2c023f20eab8a4c97ab6032a0e1.svg";
export { ForwardRef as ReactComponent };